<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__tencentadsapp}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.id" placeholder="id" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button v-if="$hasPermission('sys:tencentadsapp:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item> -->
        <el-form-item>
          <el-button v-if="$hasPermission('sys:tencentadsapp:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="id" label="主键id" header-align="center" align="center"></el-table-column>
        <el-table-column prop="appType" label="应用类型" header-align="center" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.appType == 1">
              私有应用
            </span>
            <span v-if="scope.row.appType == 0">
              第三方应用
            </span>
          </template>

          
        </el-table-column>
        <el-table-column prop="appId" label="应用id" header-align="center" align="center"></el-table-column>
        <el-table-column prop="appName" label="应用名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="appIntroduce" label="应用介绍" header-align="center" align="center"></el-table-column>
        <el-table-column prop="appTokenFetch" label="应用token" header-align="center" align="center"></el-table-column>
        <el-table-column prop="accessToken" label="accessToken" header-align="center" align="center"></el-table-column>
        <el-table-column prop="refreshToken" label="refreshToken" header-align="center" align="center"></el-table-column>
        <el-table-column prop="permissionSituation" label="权限情况" header-align="center" align="center"></el-table-column>
        <el-table-column prop="status" label="状态" header-align="center" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.appType == 1">
              启用
            </span>
            <span v-if="scope.row.appType == 0">
              禁用
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="createDate" label="创建时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="creator" label="创建人" header-align="center" align="center"></el-table-column>
        <el-table-column prop="remark" label="备注" header-align="center" align="center"></el-table-column>
        <el-table-column prop="accountId" label="广告主id" header-align="center" align="center"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <!-- <el-button v-if="$hasPermission('sys:tencentadsapp:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button> -->
            <el-button v-if="$hasPermission('sys:tencentadsapp:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './tencentadsapp-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/tencentadsapp/page',
        getDataListIsPage: true,
        exportURL: '/sys/tencentadsapp/export',
        deleteURL: '/sys/tencentadsapp',
        deleteIsBatch: true
      },
      dataForm: {
        id: ''
      }
    }
  },
  components: {
    AddOrUpdate
  }
}
</script>
